import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import "./Contact.css";

function Contact() {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    occasion: "",
    date: "",
    time: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const phoneNumber = "96170210576";

    const message = encodeURIComponent(
      `Hello, I would like to submit a booking request.

Name: ${formData.name}
Phone: ${formData.phone}
Occasion: ${formData.occasion}
Date: ${formData.date}
Time: ${formData.time}

Message:
${formData.message}`
    );

    window.open(
      `https://wa.me/${phoneNumber}?text=${message}`,
      "_blank"
    );

    setSubmitted(true);
  };

  return (
    <main className="contact-page">

      {/* HERO */}

      <section className="contact-hero">

        <span className="contact-eyebrow">
          {t("contact.label")}
        </span>

        <h1>
          {t("contact.title1")}{" "}
          <em>{t("contact.title2")}</em>
        </h1>

        <div className="contact-divider">
          <span></span>
          <i>✦</i>
          <span></span>
        </div>

        <p>
          {t("contact.description")}
        </p>

      </section>


      {/* CONTACT FORM */}

      <section className="contact-section">

        <div className="contact-form-wrapper">

          <div className="contact-form-header">

            <span>
              {t("contact.formLabel")}
            </span>

            <h2>
              {t("contact.formTitle")}
            </h2>

          </div>


          <form onSubmit={handleSubmit}>

            {/* NAME */}

            <div className="contact-field">

              <label htmlFor="name">
                {t("contact.name")}
              </label>

              <input
                id="name"
                name="name"
                type="text"
                placeholder={t(
                  "contact.namePlaceholder"
                )}
                value={formData.name}
                onChange={handleChange}
                required
              />

            </div>


            {/* PHONE */}

            <div className="contact-field">

              <label htmlFor="phone">
                {t("contact.phone")}
              </label>

              <input
                id="phone"
                name="phone"
                type="tel"
                placeholder={t(
                  "contact.phonePlaceholder"
                )}
                value={formData.phone}
                onChange={handleChange}
                required
              />

            </div>


            {/* OCCASION */}

            <div className="contact-field">

              <label htmlFor="occasion">
                {t("contact.occasion")}
              </label>

              <select
                id="occasion"
                name="occasion"
                value={formData.occasion}
                onChange={handleChange}
                required
              >

                <option value="">
                  {t(
                    "contact.occasionPlaceholder"
                  )}
                </option>

                <option value="Weddings">
                  {t(
                    "photography.categories.weddings.name"
                  )}
                </option>

                <option value="Islamic Weddings">
                  {t(
                    "photography.categories.islamicWeddings.name"
                  )}
                </option>

                <option value="Engagements">
                  {t(
                    "photography.categories.engagements.name"
                  )}
                </option>

                <option value="Bridal Sessions">
                  {t(
                    "photography.categories.bridalSessions.name"
                  )}
                </option>

                <option value="Women Events">
                  {t(
                    "photography.categories.womenEvents.name"
                  )}
                </option>

                <option value="Family & Friends">
                  {t(
                    "photography.categories.familyFriends.name"
                  )}
                </option>

              </select>

            </div>


            {/* DATE + TIME */}

            <div className="contact-row">

              <div className="contact-field">

                <label htmlFor="date">
                  {t("contact.date")}
                </label>

                <input
                  id="date"
                  name="date"
                  type="date"
                  value={formData.date}
                  onChange={handleChange}
                  required
                />

              </div>


              <div className="contact-field">

                <label htmlFor="time">
                  {t("contact.time")}
                </label>

                <input
                  id="time"
                  name="time"
                  type="time"
                  value={formData.time}
                  onChange={handleChange}
                  required
                />

              </div>

            </div>


            {/* MESSAGE */}

            <div className="contact-field">

              <label htmlFor="message">
                {t("contact.message")}
              </label>

              <textarea
                id="message"
                name="message"
                rows="6"
                placeholder={t(
                  "contact.messagePlaceholder"
                )}
                value={formData.message}
                onChange={handleChange}
              />

            </div>


            {/* SUBMIT */}

            <button
              type="submit"
              className="contact-submit"
            >

              <span>
                {t("contact.submit")}
              </span>

              <strong>
                ↗
              </strong>

            </button>


            {submitted && (
              <p className="contact-success">
                {t("contact.success")}
              </p>
            )}

          </form>

        </div>

      </section>

    </main>
  );
}

export default Contact;